module.exports = __webpack_public_path__ + "img/sysimg2.5f3447be.jpg";